import { AppDispatchNext } from 'actions/actions.typesNext'
import { ChatEventReasons } from 'actions/messengerStopChat/constants'
import { showStopChatIfNeeded } from 'actions/messengerStopChat/showStopChatIfNeeded'
import {
  SendOutsideContactStatistics,
  sendOutsideContactApi,
} from 'api/messenger/sendOutsideContactApi'

export const SEND_OUTSIDE_CONTACT = 'SEND_OUTSIDE_CONTACT' as const

export const sendOutsideContactAction =
  (
    contactUserId: number,
    serviceAlias: string,
    action: SendOutsideContactStatistics
  ) =>
  (dispatch: AppDispatchNext) => {
    return dispatch(
      sendOutsideContactPlainAction(
        dispatch,
        contactUserId,
        serviceAlias,
        action
      )
    )
  }

export const sendOutsideContactPlainAction = (
  dispatch: AppDispatchNext,
  contactUserId: number,
  serviceAlias: string,
  action: SendOutsideContactStatistics
) => ({
  type: SEND_OUTSIDE_CONTACT,
  promise: async () => {
    const response = await sendOutsideContactApi(
      contactUserId,
      serviceAlias,
      action
    )

    if (response.result?.['code']) {
      dispatch(showStopChatIfNeeded(ChatEventReasons.Send))
      return response
    }

    return response
  },
})
